var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info_config_page" },
    [
      _c(
        "div",
        { staticClass: "flex align-center table-top-btns" },
        [
          _c(
            "h5",
            { staticClass: "flex align-center" },
            [
              _c("svg-icon", {
                staticStyle: { "margin-right": "15px" },
                attrs: { "icon-class": "list", size: 15 }
              }),
              _vm._v("数据列表\n    ")
            ],
            1
          ),
          _vm.$hasMethod("#add")
            ? _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  attrs: { size: "small", icon: "el-icon-plus" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "webConfigCategoryAdd",
                        params: { type: "info" }
                      })
                    }
                  }
                },
                [_vm._v("新添品类")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            "row-key": "id",
            border: "",
            "tree-props": { children: "children" }
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "展开", width: "80" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "排序", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    !_vm.$hasMethod("#sort")
                      ? _c("span", [_vm._v(_vm._s(scope.row.cate_sort))])
                      : _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^\\d]/g,'')",
                            maxLength: "9"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeSort(
                                scope.row.id,
                                scope.row.children,
                                scope.row.cate_sort
                              )
                            }
                          },
                          model: {
                            value: scope.row.cate_sort,
                            callback: function($$v) {
                              _vm.$set(scope.row, "cate_sort", $$v)
                            },
                            expression: "scope.row.cate_sort"
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "ID" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.children
                            ? scope.row.id
                            : scope.row.id.split("-")[1]
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "板块名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("p", [
                      !scope.row.children
                        ? _c(
                            "span",
                            { staticStyle: { margin: "0 5px 0 20px" } },
                            [_vm._v("├─")]
                          )
                        : _vm._e(),
                      _vm._v(
                        _vm._s(
                          scope.row.children
                            ? scope.row.cate_name
                            : scope.row.name
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.$hasMethod("#enable")
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "pointer",
                            attrs: {
                              type: scope.row.status == 1 ? "success" : "danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.changeStatus(
                                  scope.row.id,
                                  scope.row.children
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.status == 1 ? "显示" : "隐藏")
                            )
                          ]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.status == 1 ? "success" : "danger"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.status == 1 ? "显示" : "隐藏")
                            )
                          ]
                        )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              width: "280",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.children && _vm.$hasMethod("#relate")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "webConfigCategoryAdd",
                                  params: {
                                    type: "child",
                                    editId: scope.row.id
                                  }
                                })
                              }
                            }
                          },
                          [_vm._v("关联子品类")]
                        )
                      : _vm._e(),
                    scope.row.children && _vm.$hasMethod("#edit")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "webConfigCategoryAdd",
                                  params: { type: "info", editId: scope.row.id }
                                })
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm.$hasMethod("#delete")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.removeItem(
                                  scope.row.id,
                                  scope.row.children
                                )
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("custom-page", {
        ref: "customPage",
        attrs: { total: _vm.total },
        on: { getList: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }